module.exports = __webpack_public_path__ + "fonts/TradeGothicLTStd-Bd2.459259d.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TradeGothicLTStd-Bd2.otf
// module id = ./src/assets/fonts/TradeGothicLTStd-Bd2.otf
// module chunks = 34